<template>
  <div class="l-upload" :style="{
    '--width':uploadStyle.width || '80px',
    '--height':uploadStyle.height || '80px',
    '--fontSize':uploadStyle.fontSize || '28px',
    '--borderRadius':uploadStyle.borderRadius || '6px',
  }">
    <el-upload class="avatar-uploader" ref="upload" :action="$imgurl + '/confile/upload?accesstoken=' + token" :show-file-list="false"
      :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
      <div v-if="imgUrl.includes('img-')" class="img-container">
        <img :src="$imgurl + imgUrl" class="img-container-cur" />
        <div class="img-container-mask" @click.stop>
          <i class="iconfont icongenghuan" @click="goUpload"></i>
          <i class="iconfont icona-shanchu2x" @click.stop="imgUrl = ''"></i>
        </div>
      </div>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import { confileRes } from '@/api/utils'
export default {
  // 组件名称
  name: 'lUpload',
  // 组件参数 接收来自父组件的数据
  props: {
    uploadStyle: {
      type: Object,
      default: () => {
        return {
          width: '80px',
          height: '80px',
          fontSize: '28px'
        }
      }
    },
    imgurl: {
      type: [String, Number],
      default: ''
    }
  },
  // 组件状态值
  data () {
    return {
      imgUrl: '',
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
    }
  },
  watch: {
    imgurl: {
      handler (val) {
        this.imgUrl = val
      },
      immediate: true
    }
  },
  // 组件方法
  methods: {
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'
      const isJPEG = file.type === 'image/jpeg'
      const isWEPB = file.type === 'image/webp'

      if (!isJPG && !isPNG && !isGIF && !isJPEG && !isWEPB) {
        this.$message.error('上传头像图片只能是 JPG或png或gif或jpeg 格式!')
      }
      const isLt2M = file.size / 1048576 < 5
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return (
        (isJPG && isLt2M) ||
        (isPNG && isLt2M) ||
        (isGIF && isLt2M) ||
        (isJPEG && isLt2M) ||
        (isWEPB && isLt2M)
      )
    },
    handleAvatarSuccess (res) {
      const imgurl = confileRes(res)
      this.imgUrl = imgurl
      this.$emit('update:imgurl', imgurl)
    },
    goUpload () {
      this.$refs.upload.$el.querySelector('.el-upload__input').click()
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.l-upload {
  $width:var(--width);
  $height:var(--height);
  $fontSize:var(--fontSize);
  $borderRadius:var(--borderRadius);
  width: $width;
  height: $height;
  overflow: hidden;
  .avatar-uploader{
    width: $width;
    height: $height;
    .el-upload{
      border: solid 1px #d9d9d9;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: $borderRadius;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-icon-plus{
        font-size: $fontSize;
        width: initial;
        height: initial;
      }
      .img-container{
        position: relative;
        width: 100%;
        height: 100%;
        &:hover {
          .img-container-mask {
            transform: translateX(0) !important;
          }
        }
        &-cur {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &-mask {
          position: absolute;
          width: 100%;
          height: 100%;
          transform: translateX(-150%);
          background-color: rgba(0, 0, 0, .5);
          display: flex;
          align-items: center;
          justify-content: center;
          top: 0;
          transition: .3s;
          .iconfont {
            color: #fff;
            font-size: 12px;
          }
          .icongenghuan{
            margin-right: 5px;
            &:hover {
              color: #4e86ff;
            }
          }
          .icona-shanchu2x{
            margin-left: 5px;
            &:hover {
              color: #e47470;
            }
          }
        }
      }
    }
  }
}
</style>
